import { useGet } from './useHttpHooks';
import { ArticleViewModel } from '../types';
import toQuery from '../lib/toQuery';

type GetArticleBySlugQuery = {
    slug: string;
};

const useGetArticleBySlug = (request: GetArticleBySlugQuery) =>
    useGet<ArticleViewModel>(`/api/articles/by-slug?${toQuery(request)}`, {
        errorMessage: 'GET /api/articles/by-slug'
    });

export default useGetArticleBySlug;
